import { apiRequest } from '@common/api/utils';

function requestCallback(source) {
  const url = '/invite-friends/request-callback';
  return apiRequest('POST', url, {
    callback_type: 'callback_requested',
    remarks: `Requested Callback from - ${source}`,
  });
}

function trackPostStatus(source) {
  const url = '/invite-friends/post-status';
  return apiRequest('POST', url, {
    activity_name: 'happy_flows_linkedIn_post_tracking',
    location: source,
  });
}

export default { requestCallback, trackPostStatus };
